import {Subscription} from "rxjs";
export {Subscription};

export type Message = {
	type: string;
	payload?: any;
};

export type TStyles = {
	[key: string]: string;
}
